import { VueConstructor } from "vue/types/umd";

import Page from '@/views/Page.vue';
import NewsFeed from '@/views/NewsFeed.vue';

export const ViewMap : Map<string, VueConstructor> = new Map<string, VueConstructor>();
ViewMap.set("page", Page);
ViewMap.set("news", NewsFeed);